import { liftPlanUEService } from '@/services/lift-plan-ue/lift-plan-ue-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';

export const useLiftPlanUEListQuery = (projectId: string) => {
  return useQuery({
    queryKey: projectKeys.liftPlanUE({ projectId }),
    queryFn: () => liftPlanUEService.list(projectId),
  });
};
